export const allowFiles = [
    { name: "Contrato de renta", tableName: "contrato_renta", rules:""},
    { name: "INE del inquilino", tableName: "ine_inquilino", rules:""},
    { name: "Poliza juridica o aval", tableName: "poliza_aval", rules:""},
    { name: "Contrato de compra-venta", tableName: "compra_venta", rules:""},
    { name: "Tabla de amortización", tableName: "amortizacion", rules:""},
    { name: "Escritura", tableName: "escritura", rules:""},
    { name: "Comprobante de domicilio", tableName: "comprobante_domicilio", rules:""},
    { name: "Predial", tableName: "predial", rules:""},
    { name: "Seguro", tableName: "seguro", rules:""},
    { name: "Seguro", tableName: "seguro_mortgage", rules:""},
];